import { Component } from '@angular/core';

@Component({
  selector: 'app-backtest',
  imports: [],
  templateUrl: './backtest.html',
  styleUrl: './backtest.scss',
})
export class Backtest {

}
